import dayjs from 'dayjs';
import { FC, ReactElement, useState } from 'react';

import { Button, Group, NumberInput, Select, Text } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { useForm } from '@mantine/form';

import { useMutation } from '@tanstack/react-query';

import { UserSearch } from '@/entities/User';

import { ratingApi } from '@/shared/api/rating.ts';
import { ICreateRateForDateRequest } from '@/shared/types/rating.types.ts';
import classes from '@/shared/uikit/components/input/LabelInput/LabelInput.module.css';

type Props = {
	children?: ReactElement;
	setShowForm: (isShow: boolean) => void;
};
interface IFormValues {
	person_id: number | null;
	date: Date | null;
	type: number | null;
	value: number | null;
}

export const NewRateForm: FC<Props> = ({ children, setShowForm }) => {
	const { mutate: createNewRate, isPending } = useMutation({
		mutationFn: ratingApi.createRateForDate,
		onSuccess: () => {
			setShowForm(false);
		},
	});

	const form = useForm<IFormValues>({
		initialValues: {
			person_id: null,
			date: null,
			type: null,
			value: null,
		},
		transformValues: (values) => ({
			...values,
			type: Number(values.type),
		}),
		validate: {
			person_id: (value) => (!value ? '' : null),
			date: (value) => (!value ? '' : null),
			type: (value) => (!value ? '' : null),
			value: (value) => (!value ? '' : null),
		},
	});

	return (
		<form onSubmit={form.onSubmit((values) => createNewRate(values as ICreateRateForDateRequest))}>
			<Group>
				<UserSearch setPersonId={(personId) => form.setFieldValue('person_id', personId)} />
				<DatePickerInput
					classNames={{ root: classes.root, label: classes.label, input: classes.textareaInput }}
					label={
						<Text c="#667085" fz={12} fw={500} lh="normal" tt="uppercase">
							Дата
						</Text>
					}
					radius="lg"
					w={160}
					placeholder="01 января 2024"
					valueFormat={'DD MMMM YYYY'}
					clearable
					{...form.getInputProps('date')}
				/>
				<Select
					classNames={classes}
					label={
						<Text c="#667085" fz={12} fw={500} lh="normal" tt="uppercase">
							Тип бронирования
						</Text>
					}
					placeholder="Отменённое"
					w={220}
					data={[
						{
							label: 'Отменённое',
							value: '0',
						},
						{
							label: 'Активное',
							value: '1',
						},
					]}
					{...form.getInputProps('type')}
				/>
				<NumberInput
					classNames={{ root: classes.root, label: classes.label, input: classes.input }}
					label={
						<Text c="#667085" fz={12} fw={500} lh="normal" tt="uppercase">
							Коэффициент
						</Text>
					}
					placeholder="Значение"
					w={220}
					min={0.0}
					max={100.0}
					decimalScale={2}
					decimalSeparator=","
					allowNegative={false}
					hideControls
					{...form.getInputProps('value')}
				/>
				<Button type="submit" loading={isPending} disabled={!form.isValid()}>
					Сохранить
				</Button>
				{!isPending && children}
			</Group>
		</form>
	);
};
